import classNames from "classnames";
import { Link } from "react-router-dom";

import { QueueEnum, SubQueueFilters } from "shared/reducers/casesReducer";

const isSubQueueKey = (key: string): key is keyof typeof SubQueueFilters => {
  return key in SubQueueFilters;
};

const CaseNavigationTab = ({
  queue,
  selectedQueue,
  link,
  isSubQueue,

  handleOnClick,
  gotoPage,
}: {
  queue: QueueEnum | keyof typeof SubQueueFilters | "all";
  selectedQueue?: QueueEnum | keyof typeof SubQueueFilters | "all";
  link?: string;
  isSubQueue?: boolean;

  handleOnClick?: Function;
  gotoPage: Function;
}) => {
  const props = {
    onClick: () => {
      handleOnClick && handleOnClick();
      gotoPage(0);
    },
    className: classNames(`CaseNavigation${isSubQueue ? "SubQueue" : ""}Tab`, {
      "CaseNavigationTab--selected": queue === selectedQueue,
    }),
  };
  return link ? (
    <Link to={link} {...props}>
      <span>
        {isSubQueueKey(queue) ? SubQueueFilters[queue]?.label ?? queue : queue}
      </span>
    </Link>
  ) : (
    <button type="button" {...props}>
      <span>{queue}</span>
    </button>
  );
};

export default CaseNavigationTab;
